import { useTranslation } from "@firecms/core";
import { CheckIcon, IconButton, Menu, MenuItem, TranslateIcon } from "@firecms/ui";
import {
  ADMIN_FIRECMS_LOCALES,
  normalizeFireCMSLocale,
} from "../i18n/adminLocales";
import { LocaleName, type Locale } from "../localization/constants";

export function AdminLanguageSelector() {
  const { i18n } = useTranslation();
  const active = normalizeFireCMSLocale(i18n.language);

  return (
    <div data-teamops-lang-toggle>
      <Menu
        trigger={
          <IconButton aria-label="Language">
            <TranslateIcon />
          </IconButton>
        }
      >
        {ADMIN_FIRECMS_LOCALES.map((code) => (
          <MenuItem
            key={code}
            onClick={() => void i18n.changeLanguage(code)}
          >
            <span className="flex w-full items-center justify-between gap-3">
              <span>{LocaleName[code as Locale]}</span>
              {active === code ? <CheckIcon className="w-4 h-4" /> : null}
            </span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
